module.exports = __webpack_public_path__ + "img/pregnant.d3c79bd8.svg";